module.exports = "export default {ru:{ds:{modal:{ok:'Ok',cancel:'Отменить'}}}};"